import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

// TODO: check when can we delete this entirely
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[osnSharedAspectRatio]',
})
export class AspectRatioDirective implements OnChanges {
  @Input('osnSharedAspectRatio') public ratio: string;
  private element: HTMLElement;
  private innerContainer: any;
  private parent: any;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  public ngOnChanges() {
    if (this.element) {
      this.renderer.insertBefore(this.parent, this.element, this.innerContainer);
      this.renderer.removeChild(this.parent, this.innerContainer);
    }
    this.setAspectRatio();
  }

  private setAspectRatio(): void {
    const [x, y] = this.ratio.split(':').map((val: string): number => Number.parseFloat(val));
    this.element = this.el.nativeElement as HTMLElement;
    this.parent = this.element.parentNode;

    this.innerContainer = this.renderer.createElement('div');
    this.renderer.setStyle(this.innerContainer, 'height', '0');
    this.renderer.setStyle(this.innerContainer, 'position', 'relative');
    this.renderer.setStyle(this.innerContainer, 'overflow', 'hidden');

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.renderer.setStyle(this.innerContainer, 'padding', `${(y * 50) / x}% 0`);
    this.renderer.setStyle(this.element, 'position', 'absolute');
    this.renderer.setStyle(this.element, 'top', '0');
    this.renderer.setStyle(this.element, 'width', '100%');
    this.renderer.setStyle(this.element, 'height', '100%');

    this.renderer.insertBefore(this.parent, this.innerContainer, this.element);
    this.renderer.appendChild(this.innerContainer, this.element);
  }
}
